<template>
    <div>
        <FormPicker :trigger="trigger" :formType="'form'" :title="'Choose post with optin form'" />
    </div>
</template>

<script>
import FormPicker from "./FormPicker.vue"
export default {
    components: { FormPicker },
    props: {
        trigger:  { type: Object, required: true }
    }
}
</script>
